export default "__VITE_ASSET__BOIZEU9X__"